import { Action } from "redux";

import { SET_AUTH, UNSET_AUTH } from "./constants";

export interface SetAuthAction extends Action {
  type: typeof SET_AUTH;
  user: User;
}
export const setAuth = (user: User): SetAuthAction => ({
  type: SET_AUTH,
  user,
});

export interface UnsetAuthAction extends Action {
  type: typeof UNSET_AUTH;
}
export const unsetAuth = (): UnsetAuthAction => ({
  type: UNSET_AUTH,
});

export type AuthActions = SetAuthAction | UnsetAuthAction;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/auth/actions.ts